const RECOVERY_KEY = 'gwAuthRecovery';
const ENROLLMENT_KEY = 'gwEnrollmentRedirect';
const TTL_MS = 10 * 60 * 1000;

function getRecoveryMarker() {
    try {
        const raw = sessionStorage.getItem(RECOVERY_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (Date.now() - parsed.timestamp > TTL_MS) {
            sessionStorage.removeItem(RECOVERY_KEY);
            return null;
        }
        return parsed;
    } catch (e) {
        return null;
    }
}

function clearOktaStorage() {
    try {
        const keysToRemove = [];
        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key && (key.startsWith('okta-') || key.includes('okta'))) {
                keysToRemove.push(key);
            }
        }
        keysToRemove.forEach(key => localStorage.removeItem(key));

        const sessionKeysToRemove = [];
        for (let i = 0; i < sessionStorage.length; i++) {
            const key = sessionStorage.key(i);
            if (key && (key.startsWith('okta-') || key.includes('okta'))) {
                sessionKeysToRemove.push(key);
            }
        }
        sessionKeysToRemove.forEach(key => {
            if (key !== RECOVERY_KEY && key !== ENROLLMENT_KEY) {
                sessionStorage.removeItem(key);
            }
        });
    } catch (e) {
        // best effort
    }
}

export function handleCallbackError(appConfig) {
    const path = window.location.pathname;
    const search = window.location.search;

    if (!path.includes('/callback')) return false;

    const params = new URLSearchParams(search);
    const error = params.get('error');

    if (!error) return false;

    const errorDescription = params.get('error_description') || '';
    const isUnassigned = errorDescription.includes('not assigned to the client application');

    if (error !== 'access_denied' || !isUnassigned) {
        return false;
    }

    const isEnrollment = sessionStorage.getItem(ENROLLMENT_KEY) === 'true';
    const marker = getRecoveryMarker();

    clearOktaStorage();

    const logoutConfirmationPage = window.location.origin + '/account-management/logout-confirmation';

    if (isEnrollment) {
        // Enrollment users are never sent to logout — Okta app assignment may still be
        // propagating. Keep both flags and always retry home so Jutro can pick up the
        // session once the assignment is ready.
        sessionStorage.setItem(RECOVERY_KEY, JSON.stringify({ timestamp: Date.now() }));
        window.location.href = window.location.origin + '/account-management/home';
        return true;
    }

    sessionStorage.removeItem(RECOVERY_KEY);
    localStorage.setItem('logout_reason', 'session_mismatch');

    if (marker) {
        window.location.href = logoutConfirmationPage;
        return true;
    }

    sessionStorage.setItem(RECOVERY_KEY, JSON.stringify({ timestamp: Date.now() }));
    window.location.href = logoutConfirmationPage;
    return true;
}
